import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildPluginsHeader } from "./registry";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";

export function userMatrixInviteAuthHeaders() {
  const h = { ...buildPluginsHeader() };
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
  } catch {
    /* ignore */
  }
  return h;
}

/**
 * @returns {Promise<{ sent: boolean, reason?: string | null }>}
 */
export async function postUserMatrixInviteEmail(to, inviteUrl) {
  const apiUrl = getApiBase();
  const { data } = await axios.post(
    `${apiUrl}/email/user-matrix-invite`,
    { to, inviteUrl },
    { headers: userMatrixInviteAuthHeaders() }
  );
  return {
    sent: Boolean(data?.sent),
    reason: data?.reason ?? null,
  };
}
